import { Component, Input } from '@angular/core';
import { LocationsService } from '../../services/locations';

@Component({
    selector: 'app-image-carousel',
    templateUrl: 'image-carousel.html'
})
export class ImageCarouselComponent {
    @Input() images:any[];

    constructor(public locationsService: LocationsService){

    }

    ngOnInit(){
        if (this.images.length === 0) {
            this.images = [{ image_url: './assets/img/god.jpg' }]
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/image-carousel/image-carousel.ts